webpackJsonp(["pages.projects.merge_requests.index"],{

/***/ "./issuable_bulk_update_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__issuable_bulk_update_actions__ = __webpack_require__("./issuable_bulk_update_actions.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__milestone_select__ = __webpack_require__("./milestone_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__issue_status_select__ = __webpack_require__("./issue_status_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__subscription_select__ = __webpack_require__("./subscription_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__labels_select__ = __webpack_require__("./labels_select.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable class-methods-use-this, no-new */







var HIDDEN_CLASS = 'hidden';
var DISABLED_CONTENT_CLASS = 'disabled-content';
var SIDEBAR_EXPANDED_CLASS = 'right-sidebar-expanded issuable-bulk-update-sidebar';
var SIDEBAR_COLLAPSED_CLASS = 'right-sidebar-collapsed issuable-bulk-update-sidebar';

var IssuableBulkUpdateSidebar = function () {
  function IssuableBulkUpdateSidebar() {
    _classCallCheck(this, IssuableBulkUpdateSidebar);

    this.initDomElements();
    this.bindEvents();
    this.initDropdowns();
    this.setupBulkUpdateActions();
  }

  _createClass(IssuableBulkUpdateSidebar, [{
    key: 'initDomElements',
    value: function initDomElements() {
      this.$page = $('.layout-page');
      this.$sidebar = $('.right-sidebar');
      this.$sidebarInnerContainer = this.$sidebar.find('.issuable-sidebar');
      this.$bulkEditCancelBtn = $('.js-bulk-update-menu-hide');
      this.$bulkEditSubmitBtn = $('.update-selected-issues');
      this.$bulkUpdateEnableBtn = $('.js-bulk-update-toggle');
      this.$otherFilters = $('.issues-other-filters');
      this.$checkAllContainer = $('.check-all-holder');
      this.$issueChecks = $('.issue-check');
      this.$issuesList = $('.selected_issue');
      this.$issuableIdsInput = $('#update_issuable_ids');
    }
  }, {
    key: 'bindEvents',
    value: function bindEvents() {
      var _this = this;

      this.$bulkUpdateEnableBtn.on('click', function (e) {
        return _this.toggleBulkEdit(e, true);
      });
      this.$bulkEditCancelBtn.on('click', function (e) {
        return _this.toggleBulkEdit(e, false);
      });
      this.$checkAllContainer.on('click', function (e) {
        return _this.selectAll(e);
      });
      this.$issuesList.on('change', function () {
        return _this.updateFormState();
      });
      this.$bulkEditSubmitBtn.on('click', function () {
        return _this.prepForSubmit();
      });
      this.$checkAllContainer.on('click', function () {
        return _this.updateFormState();
      });
    }
  }, {
    key: 'initDropdowns',
    value: function initDropdowns() {
      new __WEBPACK_IMPORTED_MODULE_4__labels_select__["a" /* default */]();
      new __WEBPACK_IMPORTED_MODULE_1__milestone_select__["a" /* default */]();
      Object(__WEBPACK_IMPORTED_MODULE_2__issue_status_select__["a" /* default */])();
      Object(__WEBPACK_IMPORTED_MODULE_3__subscription_select__["a" /* default */])();
    }
  }, {
    key: 'setupBulkUpdateActions',
    value: function setupBulkUpdateActions() {
      __WEBPACK_IMPORTED_MODULE_0__issuable_bulk_update_actions__["a" /* default */].setOriginalDropdownData();
    }
  }, {
    key: 'updateFormState',
    value: function updateFormState() {
      var noCheckedIssues = !$('.selected_issue:checked').length;

      this.toggleSubmitButtonDisabled(noCheckedIssues);
      this.updateSelectedIssuableIds();

      __WEBPACK_IMPORTED_MODULE_0__issuable_bulk_update_actions__["a" /* default */].setOriginalDropdownData();
    }
  }, {
    key: 'prepForSubmit',
    value: function prepForSubmit() {
      var _this2 = this;

      // if submit button is disabled, submission is blocked. This ensures we disable after
      // form submission is carried out
      setTimeout(function () {
        return _this2.$bulkEditSubmitBtn.disable();
      });
      this.updateSelectedIssuableIds();
    }
  }, {
    key: 'toggleBulkEdit',
    value: function toggleBulkEdit(e, enable) {
      e.preventDefault();

      this.toggleSidebarDisplay(enable);
      this.toggleBulkEditButtonDisabled(enable);
      this.toggleOtherFiltersDisabled(enable);
      this.toggleCheckboxDisplay(enable);
    }
  }, {
    key: 'updateSelectedIssuableIds',
    value: function updateSelectedIssuableIds() {
      this.$issuableIdsInput.val(IssuableBulkUpdateSidebar.getCheckedIssueIds());
    }
  }, {
    key: 'selectAll',
    value: function selectAll() {
      var checkAllButtonState = this.$checkAllContainer.find('input').prop('checked');

      this.$issuesList.prop('checked', checkAllButtonState);
    }
  }, {
    key: 'toggleSidebarDisplay',
    value: function toggleSidebarDisplay(show) {
      this.$page.toggleClass(SIDEBAR_EXPANDED_CLASS, show);
      this.$page.toggleClass(SIDEBAR_COLLAPSED_CLASS, !show);
      this.$sidebarInnerContainer.toggleClass(HIDDEN_CLASS, !show);
      this.$sidebar.toggleClass(SIDEBAR_EXPANDED_CLASS, show);
      this.$sidebar.toggleClass(SIDEBAR_COLLAPSED_CLASS, !show);
    }
  }, {
    key: 'toggleBulkEditButtonDisabled',
    value: function toggleBulkEditButtonDisabled(disable) {
      if (disable) {
        this.$bulkUpdateEnableBtn.disable();
      } else {
        this.$bulkUpdateEnableBtn.enable();
      }
    }
  }, {
    key: 'toggleCheckboxDisplay',
    value: function toggleCheckboxDisplay(show) {
      this.$checkAllContainer.toggleClass(HIDDEN_CLASS, !show);
      this.$issueChecks.toggleClass(HIDDEN_CLASS, !show);
    }
  }, {
    key: 'toggleOtherFiltersDisabled',
    value: function toggleOtherFiltersDisabled(disable) {
      this.$otherFilters.toggleClass(DISABLED_CONTENT_CLASS, disable);
    }
  }, {
    key: 'toggleSubmitButtonDisabled',
    value: function toggleSubmitButtonDisabled(disable) {
      if (disable) {
        this.$bulkEditSubmitBtn.disable();
      } else {
        this.$bulkEditSubmitBtn.enable();
      }
    }
  }], [{
    key: 'getCheckedIssueIds',
    value: function getCheckedIssueIds() {
      var $checkedIssues = $('.selected_issue:checked');

      if ($checkedIssues.length > 0) {
        return $.map($checkedIssues, function (value) {
          return $(value).data('id');
        });
      }

      return [];
    }
  }]);

  return IssuableBulkUpdateSidebar;
}();

/* harmony default export */ __webpack_exports__["a"] = (IssuableBulkUpdateSidebar);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issuable_index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__ = __webpack_require__("./lib/utils/axios_utils.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__flash__ = __webpack_require__("./flash.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__locale__ = __webpack_require__("./locale/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_sidebar__ = __webpack_require__("./issuable_bulk_update_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__issuable_bulk_update_actions__ = __webpack_require__("./issuable_bulk_update_actions.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







var IssuableIndex = function () {
  function IssuableIndex(pagePrefix) {
    _classCallCheck(this, IssuableIndex);

    this.initBulkUpdate(pagePrefix);
    IssuableIndex.resetIncomingEmailToken();
  }

  _createClass(IssuableIndex, [{
    key: 'initBulkUpdate',
    value: function initBulkUpdate(pagePrefix) {
      var userCanBulkUpdate = $('.issues-bulk-update').length > 0;
      var alreadyInitialized = !!this.bulkUpdateSidebar;

      if (userCanBulkUpdate && !alreadyInitialized) {
        __WEBPACK_IMPORTED_MODULE_4__issuable_bulk_update_actions__["a" /* default */].init({
          prefixId: pagePrefix
        });

        this.bulkUpdateSidebar = new __WEBPACK_IMPORTED_MODULE_3__issuable_bulk_update_sidebar__["a" /* default */]();
      }
    }
  }], [{
    key: 'resetIncomingEmailToken',
    value: function resetIncomingEmailToken() {
      var $resetToken = $('.incoming-email-token-reset');

      $resetToken.on('click', function (e) {
        e.preventDefault();

        $resetToken.text('resetting...');

        __WEBPACK_IMPORTED_MODULE_0__lib_utils_axios_utils__["a" /* default */].put($resetToken.attr('href')).then(function (_ref) {
          var data = _ref.data;

          $('#issuable_email').val(data.new_address).focus();

          $resetToken.text('reset it');
        }).catch(function () {
          Object(__WEBPACK_IMPORTED_MODULE_1__flash__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_2__locale__["__"])('There was an error when reseting email token.'));

          $resetToken.text('reset it');
        });
      });
    }
  }]);

  return IssuableIndex;
}();

/* harmony default export */ __webpack_exports__["a"] = (IssuableIndex);
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./issue_status_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = issueStatusSelect;
function issueStatusSelect() {
  $('.js-issue-status').each(function (i, el) {
    var fieldName = $(el).data('field-name');
    return $(el).glDropdown({
      selectable: true,
      fieldName: fieldName,
      toggleLabel: function toggleLabel(selected, element, instance) {
        var label = 'Author';
        var $item = instance.dropdown.find('.is-active');
        if ($item.length) {
          label = $item.text();
        }
        return label;
      },
      clicked: function clicked(options) {
        return options.e.preventDefault();
      },
      id: function id(obj, element) {
        return $(element).data('id');
      }
    });
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./pages/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FILTERED_SEARCH; });
/* eslint-disable import/prefer-default-export  */

var FILTERED_SEARCH = {
  MERGE_REQUESTS: 'merge_requests',
  ISSUES: 'issues'
};

/***/ }),

/***/ "./pages/projects/constants.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ISSUABLE_INDEX; });
/* eslint-disable import/prefer-default-export  */

var ISSUABLE_INDEX = {
  MERGE_REQUEST: 'merge_request_',
  ISSUE: 'issue_'
};

/***/ }),

/***/ "./pages/projects/merge_requests/index/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__issuable_index__ = __webpack_require__("./issuable_index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortcuts_navigation__ = __webpack_require__("./shortcuts_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__users_select__ = __webpack_require__("./users_select.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_search_init_filtered_search__ = __webpack_require__("./pages/search/init_filtered_search.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_constants__ = __webpack_require__("./pages/constants.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__pages_projects_constants__ = __webpack_require__("./pages/projects/constants.js");







document.addEventListener('DOMContentLoaded', function () {
  Object(__WEBPACK_IMPORTED_MODULE_3__pages_search_init_filtered_search__["a" /* default */])({
    page: __WEBPACK_IMPORTED_MODULE_4__pages_constants__["a" /* FILTERED_SEARCH */].MERGE_REQUESTS
  });
  new __WEBPACK_IMPORTED_MODULE_0__issuable_index__["a" /* default */](__WEBPACK_IMPORTED_MODULE_5__pages_projects_constants__["a" /* ISSUABLE_INDEX */].MERGE_REQUEST); // eslint-disable-line no-new
  new __WEBPACK_IMPORTED_MODULE_1__shortcuts_navigation__["a" /* default */](); // eslint-disable-line no-new
  new __WEBPACK_IMPORTED_MODULE_2__users_select__["a" /* default */](); // eslint-disable-line no-new
});

/***/ }),

/***/ "./pages/search/init_filtered_search.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (_ref) {
  var page = _ref.page;

  var filteredSearchEnabled = gl.FilteredSearchManager && document.querySelector('.filtered-search');
  if (filteredSearchEnabled) {
    var filteredSearchManager = new gl.FilteredSearchManager({ page: page });
    filteredSearchManager.setup();
  }
});

/***/ }),

/***/ "./shortcuts_navigation.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap__ = __webpack_require__("../../../node_modules/mousetrap/mousetrap.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_mousetrap___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_mousetrap__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__ = __webpack_require__("./shortcuts_dashboard_navigation.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__shortcuts__ = __webpack_require__("./shortcuts.js");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var ShortcutsNavigation = function (_Shortcuts) {
  _inherits(ShortcutsNavigation, _Shortcuts);

  function ShortcutsNavigation() {
    _classCallCheck(this, ShortcutsNavigation);

    var _this = _possibleConstructorReturn(this, (ShortcutsNavigation.__proto__ || Object.getPrototypeOf(ShortcutsNavigation)).call(this));

    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g p', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g e', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-project-activity');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g f', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-tree');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g c', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-commits');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g j', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-builds');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g n', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-network');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g d', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-repository-charts');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issues');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g b', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-issue-boards');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g m', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-merge_requests');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g t', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-todos');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g w', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-wiki');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('g s', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-snippets');
    });
    __WEBPACK_IMPORTED_MODULE_0_mousetrap___default.a.bind('i', function () {
      return Object(__WEBPACK_IMPORTED_MODULE_1__shortcuts_dashboard_navigation__["a" /* default */])('.shortcuts-new-issue');
    });

    _this.enabledHelp.push('.hidden-shortcut.project');
    return _this;
  }

  return ShortcutsNavigation;
}(__WEBPACK_IMPORTED_MODULE_2__shortcuts__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ShortcutsNavigation);

/***/ }),

/***/ "./subscription_select.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony export (immutable) */ __webpack_exports__["a"] = subscriptionSelect;
function subscriptionSelect() {
  $('.js-subscription-event').each(function (i, element) {
    var fieldName = $(element).data('field-name');

    return $(element).glDropdown({
      selectable: true,
      fieldName: fieldName,
      toggleLabel: function toggleLabel(selected, el, instance) {
        var label = 'Subscription';
        var $item = instance.dropdown.find('.is-active');
        if ($item.length) {
          label = $item.text();
        }
        return label;
      },
      clicked: function clicked(options) {
        return options.e.preventDefault();
      },
      id: function id(obj, el) {
        return $(el).data('id');
      }
    });
  });
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ })

},["./pages/projects/merge_requests/index/index.js"]);


// WEBPACK FOOTER //
// pages.projects.merge_requests.index.dd0150e6bc8edadbb8b8.bundle.js